import styles from "./styles.module.css";
type slideProps = {
  size: number;
};
const Slider = ({ size }: slideProps) => {
  return (
    <div className={styles.slider}>
      <div className={styles.indicator} style={{ width: `${size}%` }}></div>
    </div>
  );
};

export default Slider;
